<script>
  import {Line} from 'vue-chartjs'

  export default {
    name: "VendasPorPeriodo",
    extends: Line,
    props: {dados:''},

    computed: {
      chartData1() {
        return this.dados.periodo1;
      },
      chartData2() {
        return this.dados.periodo2;
      }
    },

    methods: {
      renderizarGrafico() {

        let data = {
          labels: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'],
          datasets: [
            {
              label: 'Mês Atual',
              data: this.chartData1,
              borderColor: "#3e95cd",
              fill: false
            },
            {
              label: 'Mês Anterior',
              data: this.chartData2,
              borderColor: "#8e5ea2",
              fill: false
            }
          ]
        };

        let options = {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        };

        this.renderChart(data, options)
      },

    },

    watch: {
      dados() {
        this.$data._chart.destroy();
        this.renderizarGrafico();
      }
    },

    mounted() {
      this.renderizarGrafico();
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/relatorio/graficos/ComparativoPorPeriodo.vue